import React, { useState, useContext } from "react";
import { Box } from "@mui/material";
import AdminInMassegeView from "./AdminInMassegeView";
import AdminOutMassegeView from "./AdminOutMassegeView";
import AdminWebhookView from "./AdminWebhookView";
import AuthContext from "../store/AuthContext";
import CustomTabs from "../component/CustomTabs";
import AdminNotificationsView from "./AdminNotificationsView";
import MessageIcon from '@mui/icons-material/Message';
import LinkIcon from '@mui/icons-material/Link';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AdminNews from "./AdminNews";
import CreditcardForm from "../component/CreditcardForm";
import CommenBBPSView from "./CommenBBPSView";
import BBPSView from "./BBPSView";
import CreditCardPipe2 from "./CreditCardPipe2";
const CreaditCardNew = ({resetView}) => {
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const [value, setValue] = useState(0); 

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = [
   
    { label: "Pipe 1", content: <CreditcardForm resetView={resetView} />,icon:<LinkIcon sx={{ color: "#ee6c4d" }}/> },
    { label: "Pipe 2(Instant)", content: <CreditCardPipe2 type="C15"  resetView={resetView}/>,icon:<NotificationsIcon sx={{ color: "#ee6c4d" }}/>},
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <CustomTabs
        tabs={tabs}
        value={value}
        onChange={handleChange}
       
      />
    </Box>
  );
};

export default CreaditCardNew;
